import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { Follow } from '@app/models/follow';
import { ApiService } from '@app/services/api/api.service';
import {
  LoadByFollow,
  LoadByFollowFail,
  LoadByFollowSuccess,
  AddMany,
  FollowCountryActionTypes
} from '@core/actions/follow-country.actions';
import { Country } from '@app/models';

@Injectable()
export class FollowCountryEffects {
  @Effect()
  loadByFollow$: Observable<Action> = this.actions$.pipe(
    ofType<LoadByFollow>(FollowCountryActionTypes.LoadByFollow),
    map(action => action.id),
    switchMap(id => {
      return this.api.getFollowCountries(id).pipe(
        map(
          (countries: Country[]) =>
            new LoadByFollowSuccess(
              countries.map(c => {
                return { FollowId: id, index: '' + id + c.id, ...c };
              })
            )
        ),
        catchError(error => of(new LoadByFollowFail(error)))
      );
    })
  );

  @Effect()
  loadByFollowSuccess$: Observable<Action> = this.actions$.pipe(
    ofType<LoadByFollowSuccess>(FollowCountryActionTypes.LoadByFollowSuccess),
    map(action => new AddMany(action.countries))
  );

  constructor(private actions$: Actions, private api: ApiService) {}
}
